var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"max-width":"100%","fluid":""}},[_c('CRUDEquipamentos')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }